<template>
    <form-row title="Security" :label_align_top="true" class="pt-0">
        <div class="w-full flex flex-col">
            <input-radio-boolean
                name="has_security"
                v-model="has_security"
                true="Yes"
                false="No"
                class="pt-2"
                :read_only="read_only"
            />

            <div v-if="has_security" class="pt-6 pb-2">
                <div class="flex">
                    <input-money
                        class="mr-6"
                        label="Cost"
                        placeholder="Cost"
                        name="security_cost"
                        v-model="security_cost"
                        :read_only="read_only"
                    />

                    <input-text
                        class="mr-6"
                        label="Building sq.ft."
                        v-model="square_feet"
                        :read_only="true"
                    />

                    <input-money
                        label="Cost/sq.ft."
                        :value="cost_per_square_foot"
                        :read_only="true"
                    />
                </div>

                <input-text
                    class="w-full pt-3"
                    label="Contract company"
                    placeholder="Company name"
                    name="security_company"
                    :value="commercial.security_company"
                    :read_only="read_only"
                />

                <input-textarea
                    class="w-full pt-3"
                    placeholder="Contact information"
                    name="security_company_contact_info"
                    :value="commercial.security_company_contact_info"
                    :rows="3"
                    :read_only="read_only"
                />
            </div>
        </div>
    </form-row>
</template>

<script>
import MoneyFunctions from '../../../mixins/money-functions.js';

export default {
    mixins: [
        MoneyFunctions,
    ],

    props: {
        read_only: { default: false },
        commercial: {},
    },

    data() {
        return {
            has_security: this.commercial.has_security,
            security_cost: this.commercial.security_cost,
        }
    },

    computed: {
        square_feet: {
            get() {
                return store.state.square_feet || null;
            },
            set(val) {
                store.state.square_feet = val;
            },
        },
        cost_per_square_foot() {
            return this.security_cost && this.square_feet
                ? Math.round(this.formatMoney(this.security_cost) / parseInt(this.square_feet) * 100) / 100
                : null;
        },
    },
}
</script>
